import { useEffect, useState } from 'react';

import { getCountryOptions } from '../utils/countryUtils';

/**
 * Hook to get localized country options and find the name for a specific country code
 * @param locale - The locale to use for country names (e.g., 'en-us', 'fr-fr')
 * @param countryCode - Optional country code to look up (e.g., 'US', 'CA')
 * @returns Object containing country options array and the selected country name (if countryCode provided)
 */
export const useCountryName = (
  locale: string,
  countryCode?: string
): { countryOptions: Array<{ value: string; label: string }>; countryName?: string } => {
  const [countryOptions, setCountryOptions] = useState<Array<{ value: string; label: string }>>([]);

  useEffect(() => {
    const loadCountryOptions = async (): Promise<void> => {
      const options = await getCountryOptions(locale);
      setCountryOptions(options);
    };

    loadCountryOptions();
  }, [locale]);

  const selectedCountry = countryCode
    ? countryOptions.find((option) => option.value === countryCode)
    : undefined;

  return {
    countryOptions,
    countryName: selectedCountry?.label,
  };
};
